import { useState } from 'react';
import Icon from '@mdi/react';
import { mdiPlusCircleOutline, mdiMinusCircleOutline } from '@mdi/js';

const IconPayment = (props) => {
    const [isExpanded, setExpanded] = useState(false);

    function expandDetails(id) {
        let elArr = document.querySelectorAll(`[id='${id}']`);
        elArr.forEach((el) => {
            if (el.hidden) el.hidden = false;
            else el.hidden = true;
        });
        setExpanded(!isExpanded);
    }

    return (
        <Icon
            onClick={() => expandDetails(props.id)}
            size={1}
            path={isExpanded ? mdiMinusCircleOutline : mdiPlusCircleOutline}
            color={isExpanded ? '#CC0033' : 'green'}
        ></Icon>
    );
};

export default IconPayment;
